// import React, { useState } from "react";
// import { FaDownload } from "react-icons/fa";
// import "../../Styles/TalentPublication.css";

// import pub1 from "../../assets/1.png";
// import pub2 from "../../assets/2.png";
// import pub3 from "../../assets/3.png";
// import pub4 from "../../assets/4.png"
// import Youtube from "./Youtube";

// const publications = [
//   { id: 1, title: "Talent Publication Vol. 1", img: pub1, link: pub1 },
//   { id: 2, title: "Talent Publication Vol. 2", img: pub2, link: pub2 },
//   { id: 3, title: "Talent Publication Vol. 3", img: pub3, link: pub3 },
//   { id: 4, title: "Talent Publication Vol. 4", img: pub4, link: pub4 },
// ];

// const TalentPublication = () => {
//   const [selected, setSelected] = useState(null);

//   const handleDownload = () => {
//     if (selected) {
//       const link = document.createElement("a");
//       link.href = selected.link;
//       link.download = selected.title;
//       link.click();
//     }
//   };

//   return (
//     <div className="main-sec">
//     <section className="talent-section" id="talent">
      
//       <div className="talent-content">
//         <h2 className="talent-hed">TALENT PUBLICATION</h2>
//         <p className="talent-cont">
//           Showcase your top talent and attract more of it. Our Talent
//           Publication service highlights your team's expertise and achievements,
//           positioning your company as an industry leader and a top destination
//           for candidates.
//         </p>
//       </div>

//       <div className="talent-left">
//         <div className="talent-cards">
//           {publications.map((item) => (
//             <div
//               key={item.id}
//               className={`talent-card ${
//                 selected?.id === item.id ? "selected" : ""
//               }`}
//               onClick={() => setSelected(item)}
//             >
//               <img src={item.img} alt={item.title} className="talent-image" />
//             </div>
//           ))}
//         </div>

//         <div className="talent-download-center">
//           <button
//             className="download-btn single-download-btn"
//             onClick={handleDownload}
//             disabled={!selected}
//           >
//             <FaDownload className="download-icon" /> Download
//           </button>
//         </div>
//       </div>
//     </section>
//     <Youtube/>
//     </div>
//   );
// };

// export default TalentPublication;




// import React, { useState } from "react";
// import { FaDownload } from "react-icons/fa";
// import "../../Styles/TalentPublication.css";

// import pub1 from "../../assets/1.png";
// import pub2 from "../../assets/2.png";
// import pub3 from "../../assets/3.png";
// import pub4 from "../../assets/4.png";
// import pub5 from "../../assets/newTalent.png";
// import pub6 from "../../assets/newtalent2.png";
// import Youtube from "./Youtube";

// const publications = [
//   { id: 1, title: "Talent Publication Vol. 1", img: pub1, link: pub1 },
//   { id: 2, title: "Talent Publication Vol. 2", img: pub2, link: pub2 },
//   { id: 3, title: "Talent Publication Vol. 3", img: pub3, link: pub3 },
//   { id: 4, title: "Talent Publication Vol. 4", img: pub4, link: pub4 },
//   //  { id: 5, title: "Talent Publication Vol. 1", img: pub5, link: pub5 },
//   //   { id: 6, title: "Talent Publication Vol. 2", img: pub6, link: pub6 },
//     //  { id: 7, title: "Talent Publication Vol. 3", img: pub2, link: pub2 },
// ];

// const TalentPublication = () => {
//   const [selected, setSelected] = useState(null);

//   const handleDownload = () => {
//     if (selected) {
//       const link = document.createElement("a");
//       link.href = selected.link;
//       link.download = selected.title;
//       link.click();
//     }
//   };

//   return (
//     <div className="main-sec">
//       <section className="talent-section">

//         {/* ✅ Content FIRST */}
//         <div className="talent-content">
//           <h2 className="talent-hed">TALENT PUBLICATION</h2>
//           <p className="talent-cont">
//             Showcase your top talent and attract more of it. Our Talent
//             Publication service highlights your team's expertise and achievements,
//             positioning your company as an industry leader and a top destination
//             for candidates.
//           </p>
//         </div>

//         {/* ✅ Carousel Section */}
//         <div className="talent-left">
//          <div className="talent-slider">
//   <div className="talent-track">
//     {[...publications, ...publications].map((item, index) => (
//       <div
//         key={index}
//         className={`talent-card ${
//           selected?.id === item.id ? "selected" : ""
//         }`}
//         onClick={() => setSelected(item)}
//       >
//         <img src={item.img} alt={item.title} />
//       </div>
//     ))}
//   </div>
// </div>

//           <div className="talent-download-center">
//             <button
//               className="download-btn"
//               onClick={handleDownload}
//               disabled={!selected}
//             >
//               <FaDownload /> Download
//             </button>
//           </div>
//         </div>

//       </section>

//       <Youtube />
//     </div>
//   );
// };

// export default TalentPublication;



// import React, { useState } from "react";
// import { FaDownload } from "react-icons/fa";
// import { Document, Page, pdfjs } from "react-pdf";
// import "../../Styles/TalentPublication.css";

// import pub1 from "../../assets/1.png";
// import pub2 from "../../assets/2.png";

// import mag1 from "../../assets/Apple.pdf";
// import mag2 from "../../assets/reactjs_tutorial.pdf";

// // ✅ SOUND (put in public/sounds/)
// const flipSound = "/sounds/flip.wav";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// const publications = [
//   { id: 1, title: "Volume 1", img: pub1, file: mag1 },
//   { id: 2, title: "Volume 2", img: pub2, file: mag2 },
// ];

// const TalentPublication = () => {
//   const [selected, setSelected] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1);

//   const openViewer = (item) => {
//     setSelected(item);
//     setOpen(true);
//     setPageNumber(1);
//   };

//   const playSound = () => {
//     const audio = new Audio(flipSound);
//     audio.play();
//   };

//   const nextPage = () => {
//     if (pageNumber + 2 <= numPages) {
//       setPageNumber(pageNumber + 2);
//       playSound();
//     }
//   };

//   const prevPage = () => {
//     if (pageNumber - 2 >= 1) {
//       setPageNumber(pageNumber - 2);
//       playSound();
//     }
//   };

//   const handleDownload = () => {
//     const link = document.createElement("a");
//     link.href = selected.file;
//     link.download = selected.title;
//     link.click();
//   };

//   return (
//     <div className="main-sec">
//       <section className="talent-section">

//         {/* CONTENT */}
//         <div className="talent-content">
//           <h2>TALENT PUBLICATION</h2>
//           <p>
//             Showcase your top talent and attract more of it. Highlight achievements
//             and build your brand.
//           </p>
//         </div>

//         {/* CAROUSEL */}
//         <div className="talent-slider">
//           <div className="talent-track">
//             {[...publications, ...publications].map((item, index) => (
//               <div
//                 key={index}
//                 className="talent-card"
//                 onClick={() => openViewer(item)}
//               >
//                 <img src={item.img} alt={item.title} />
//               </div>
//             ))}
//           </div>
//         </div>

//       </section>

//       {/* MODAL */}
//       {open && (
//         <div className="modal-overlay">
//           <div className="modal-content">

//             <span className="close" onClick={() => setOpen(false)}>✖</span>

//             <Document
//               file={selected.file}
//               onLoadSuccess={({ numPages }) => setNumPages(numPages)}
//             >
//               <div className="book-view">

//                 {/* LEFT PAGE */}
//                 <Page pageNumber={pageNumber} />

//                 {/* RIGHT PAGE */}
//                 {pageNumber + 1 <= numPages && (
//                   <Page pageNumber={pageNumber + 1} />
//                 )}

//               </div>
//             </Document>

//             <div className="controls">
//               <button onClick={prevPage}>⬅ Prev</button>
//               <span>
//                 {pageNumber}-{Math.min(pageNumber + 1, numPages)} / {numPages}
//               </span>
//               <button onClick={nextPage}>Next ➡</button>
//             </div>

//             <button className="download-btn" onClick={handleDownload}>
//               <FaDownload /> Download
//             </button>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TalentPublication;




// import React, { useState } from "react";
// import HTMLFlipBook from "react-pageflip";
// import { FaDownload } from "react-icons/fa";
// import "../../Styles/TalentPublication.css";

// const publications = [
//   {
//     id: 1,
//     title: "Volume 1",
//     file: "/pdf/reactjs_tutorial.pdf",
//   },
// ];

// const flipSound = "/sounds/flip.wav";

// const TalentPublication = () => {
//   const [selected, setSelected] = useState(null);
//   const [open, setOpen] = useState(false);

//   const openViewer = (item) => {
//     setSelected(item);
//     setOpen(true);
//   };

//   const playSound = () => {
//     const audio = new Audio(flipSound);
//     audio.play().catch(() => {});
//   };

//   const handleDownload = () => {
//     window.open(selected.file);
//   };

//   return (
//     <div className="main-sec">
//       <section className="talent-section">

//         {/* HEADER */}
//         <div className="talent-content">
//           <h2>TALENT PUBLICATION</h2>
//           <p>Showcase your top talent and attract more of it.</p>
//         </div>

//         {/* 🔥 AUTO SCROLL CAROUSEL */}
//         <div className="talent-slider">
//           <div className="talent-track">
//             {[...publications, ...publications].map((item, index) => (
//               <div
//                 key={index}
//                 className="talent-card"
//                 onClick={() => openViewer(item)}
//               >
//                 {/* ✅ ONLY FIRST PAGE */}
//                 <iframe
//                   src={`${item.file}#page=1`}
//                   className="pdf-preview"
//                   title={item.title}
//                 />
//                 <p className="mag-title">{item.title}</p>
//               </div>
//             ))}
//           </div>
//         </div>

//       </section>

//       {/* 🔥 POPUP BOOK */}
//       {open && (
//         <div className="modal-overlay">
//           <div className="modal-content">

//             <span className="close" onClick={() => setOpen(false)}>✖</span>

//             {/* ✅ REAL FLIP BOOK */}
//             <HTMLFlipBook
//               width={400}
//               height={550}
//               size="stretch"
//               minWidth={300}
//               maxWidth={700}
//               minHeight={400}
//               maxHeight={900}
//               showCover={true}
//               mobileScrollSupport={true}
//               onFlip={playSound}
//               className="flip-book"
//             >
//               {/* 🔥 PAGES */}
//               {[...Array(10)].map((_, i) => (
//                 <div className="page" key={i}>
//                   <iframe
//                     src={`${selected.file}#page=${i + 1}`}
//                     title={`page-${i}`}
//                   />
//                 </div>
//               ))}
//             </HTMLFlipBook>

//             {/* DOWNLOAD */}
//             <button className="download-btn" onClick={handleDownload}>
//               <FaDownload /> Download
//             </button>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default TalentPublication;


import React, { useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import audio from "../../assets/paper-sound1.wav";
import audio1 from "../../assets/papertone.wav";
import { FaDownload } from "react-icons/fa";
import { Document, Page, pdfjs } from "react-pdf";
import "../../Styles/TalentPublication.css";
import Youtube from "./Youtube";
// ✅ Worker (must exist in public folder)
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const publications = [
  {
    id: 1,
    title: "Siva Krishna",
    file: "/pdf/nhrc-document.pdf",
  },
  {
    id: 2,
    title: "Padma",
    file: "/pdf/nhrc-board-2.pdf",
  },
  {
    id: 3,
    title: "Veera Chappi",
    file: "/pdf/nhrc-board-3.pdf",
  },
  {
    id: 4,
    title: "Yaswanth",
    file: "/pdf/nhrc-board-4.pdf",
  },
];

const TalentPublication = () => {
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const [numPages, setNumPages] = useState(0);

  const flipBookRef = useRef();

  // 🔥 Preload both paper-sound audio objects once, reuse on every flip
  const flipAudioRef = useRef(new Audio(audio));
  const flipAudioRef1 = useRef(new Audio(audio1));

  const openViewer = (item) => {
    setSelected(item);
    setOpen(true);
  };

  // 🔥 Play the imported paper-sound effect (alternates between the two tones)
  const playSound = () => {
    // Reset playback position so rapid flips always play from the start
    flipAudioRef.current.currentTime = 0;
    flipAudioRef.current.play().catch(() => {});
  };

  const playSound1 = () => {
    flipAudioRef1.current.currentTime = 0;
    flipAudioRef1.current.play().catch(() => {});
  };

  const nextPage = () => {
    flipBookRef.current.pageFlip().flipNext();
    playSound();
  };

  const prevPage = () => {
    flipBookRef.current.pageFlip().flipPrev();
    playSound1();
  };

  const handleDownload = () => {
    window.open(selected.file);
  };

  return (
    <div className="main-sec " id="talant">
      <section className="talent-section">

        <div className="talent-content">
          <h2>TALENT PUBLICATION</h2>
          <p className="talent-cont">
            Showcase your top talent and attract more of it. Our Talent
            Publication service highlights your team's expertise and achievements,
            positioning your company as an industry leader and a top destination
            for candidates.
          </p>
        </div>

        <div className="talent-slider">
          <div className="talent-track">
            {[...publications, ...publications].map((item, index) => (
              <div
                key={index}
                className="talent-card"
                onClick={() => openViewer(item)}
              >
                <Document file={item.file}>
                  <Page pageNumber={1} width={200} />
                </Document>
                <p className="mag-title">{item.title}</p>
              </div>
            ))}
          </div>
        </div>

      </section>

      {/* 🔥 MODAL */}
      {open && (
        <div className="modal-overlay-talant">
          <div className="modal-content-talant">

            <span className="close-talant" onClick={() => setOpen(false)}>✖</span>

            <Document
              file={selected.file}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              loading={<p>Loading PDF...</p>}
              error={<p>Failed to load PDF</p>}
            >
              {numPages > 0 && (
                <HTMLFlipBook
                  ref={flipBookRef}
                  width={350}
                  height={400}
                  showCover={true}
                  usePortrait={false} // 🔥 2 pages view
                  className="flip-book"
                  onFlip={playSound}
                >
                  {Array.from(new Array(numPages), (_, index) => (
                    <div key={index} className="page">
                      <Page pageNumber={index + 1} width={380} />
                    </div>
                  ))}
                </HTMLFlipBook>
              )}
            </Document>

            {/* 🔥 CONTROLS */}
            <div className="controls-talant">
              <button onClick={prevPage}>⬅ Prev</button>
              <button onClick={nextPage}>Next ➡</button>
            </div>

            {/* DOWNLOAD */}
            <button className="download-btn-talant" onClick={handleDownload}>
              <FaDownload /> Download
            </button>

          </div>
        </div>
      )}
      <Youtube/>
    </div>
  );
};

export default TalentPublication;